import api from "./cofocusAPI";

async function awardMedal(UID) {
  if (!UID) return false;
  return await api.getResponseData({
    url: `/api/users/awardMedal`,
    method: "post",
    data: {
      UID,
    },
    withCredentials: true,
  });
}

async function removeMedal(UID) {
  if (!UID) return false;
  return await api.getResponseData({
    url: `/api/users/removeMedal`,
    method: "post",
    data: {
      UID,
    },
    withCredentials: true,
  });
}

export default {
  awardMedal,
  removeMedal,
};
